const StandardColors = {
  primary_color: "#357EFF",

  background: "#F6F8FF",
  white: "#ffffff",
  black_100: "#000000",
  black_80: "rgba(0, 0, 0, 0.8)",
  black_60: "rgba(0, 0, 0, 0.6)",
  black_40: "rgba(0, 0, 0, 0.4)",
  black_20: "rgba(0, 0, 0, 0.2)",
  black_10: "rgba(0, 0, 0, 0.1)",
  primary_blue_100: "#3A82FB",
  primary_blue_80: "rgba(58, 130, 251, 0.8)",
  primary_blue_60: "rgba(58, 130, 251, 0.6)",
  primary_blue_40: "rgba(58, 130, 251, 0.4)",
  primary_blue_20: "rgba(58, 130, 251, 0.2)",
  primary_blue_10: "rgba(58, 130, 251, 0.1)",
  primary_blue_dark_5: "#010919",
  primary_blue_dark_10: "#021231",
  primary_blue_dark_15: "#042362",
  secondary_red_100: "#FD7272",
  secondary_red_20: "rgba(253, 114, 114, 0.2)",
  secondary_blue_100: "#1FB5FC",
  secondary_blue_10: "rgba(31, 181, 252, 0.1)",
  secondary_green_100: "#23D199",
  secondary_teal_100: "#26DCF0",
  secondary_purple_100: "#D573E5",
  secondary_orange_100: "#FD9483",
  gradient_teal:
    " linear-gradient(180deg, rgba(38, 220, 240, 0.4) 13.31%, rgba(38, 220, 240, 0) 100%);",
  gradient_purple:
    "linear-gradient(180deg, rgba(213, 115, 229, 0.4) -5.04%, rgba(213, 115, 229, 0) 100%);",
  gradient_orange:
    "linear-gradient(180deg, rgba(253, 148, 131, 0.4) 13.31%, rgba(253, 148, 131, 0) 100%)",
  shadow: "#6D6D8C",
  new_shadow_color: "#E6ECF8"
};

export default StandardColors;
